import { createContext, useContext } from 'react'

/**
 * Widget Preview Context
 *
 * Marks the subtree rendered by `WidgetPreview` as showing an unsaved draft.
 *
 * A widget rendered inside the config dialog looks exactly like the one on the
 * dashboard, and its chart component fetches its own data. Without this flag it
 * would write half-edited results under the saved widget's react-query key, so
 * closing the dialog without saving would leave the dashboard showing the
 * abandoned edit. The data hooks read this and switch to a separate key
 * namespace that is never persisted.
 *
 * `WidgetPreview` renders `WidgetPreviewContext.Provider` itself, so this file
 * holds no component and stays a plain module.
 */
const WidgetPreviewContext = createContext(false)

/**
 * @returns {boolean} Whether the caller is rendered inside a widget preview
 */
export function useIsWidgetPreview() {
  return useContext(WidgetPreviewContext)
}

export default WidgetPreviewContext
